import type { BannerProps, TeaserProps } from '../../types';

export const checkMissingText = (props: Partial<BannerProps | TeaserProps>) =>
  Boolean(
    !props?.title && !props?.subtitle && !props?.campaignDuration && !props?.countdownEndDate
  );
